/**
 * Reloj digital de la ready room — Fase 5g.3.
 *
 * Pinta fecha y hora en la pantalla rectangular de la pared, a la
 * derecha del proyector. El color (verde de día, rojo de noche) lo fija
 * `ready-room.css` según `data-time-of-day`.
 *
 * La hora va en `HH:MM` (sin segundos): la fuente de 7 segmentos es
 * ancha y, en una pantalla tan pequeña, 8 caracteres no permitirían un
 * tamaño legible. Con 5 caracteres la hora se ve grande.
 */

const pad = (n: number): string => String(n).padStart(2, '0');

/**
 * Engancha el reloj a los spans `[data-clock-time]` y `[data-clock-date]`
 * y arranca el tick. Si los spans no existen, no hace nada.
 */
export function startReadyRoomClock(): void {
  const timeEl = document.querySelector<HTMLElement>('[data-clock-time]');
  const dateEl = document.querySelector<HTMLElement>('[data-clock-date]');
  if (!timeEl || !dateEl) return;

  const tick = (): void => {
    const now = new Date();
    timeEl.textContent = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
    dateEl.textContent =
      `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.` +
      String(now.getFullYear()).slice(2);
  };
  tick();
  // Tick cada 10 s — basta para que la hora ruede al cambiar de minuto.
  window.setInterval(tick, 10_000);
}
